exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-item-trunc-long-text{display:block;width:350px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;word-break:break-word}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/common/pricing/add-item-modal/styles/AddItemStyles.scss
// module id = 5853
// module chunks = 0